<template>
	<!--蔬菜客诉-->
	<div class="wrap">
		<div class="header">
			<div class="top">
				<i class="close" @click="backHome"></i>
				<p class="title">蔬菜客诉</p>
			</div>
			<div class="nav">
				<div
					class="nav-li"
					:class="{ active: navItem.name === item.name }"
					v-for="(item, index) in navList"
					@click.stop="navListClick(item)"
					:key="index"
				>
					{{ item.name }}
				</div>
			</div>
		</div>
		<div class="content">
			<div class="date-select" @click="show = true">
				<i class="icon-date"></i>
				<p class="date" :class="{ active: date }">
					{{ date || "选择反馈日期" }}
				</p>
				<i class="icon-more"></i>
			</div>
			<div class="data-li" v-for="(item, index) in list" :key="index">
				<div class="li-top">
					<p class="bg">
						<span class="date">{{ item.complaintDate }}</span>
					</p>
					<p class="type-name" v-if="item.complaintStateName">
						{{ item.complaintStateName }}
					</p>
				</div>
				<p class="li-store-name">
					{{ item.groupName }}-{{ item.retailName }}
				</p>
				<p class="li-supplier-name">{{ item.providerName }}</p>
				<div class="li-number">
					<p class="li-number-p1">客诉单号：{{ item.code }}</p>
					<p class="li-number-p2">反馈人：{{ item.createByName }}</p>
				</div>
				<div class="raw-detail">
					<div class="raw-detail-top" @click="showItem(item, index)">
						<p class="raw-detail-top-p1">原料详情</p>
						<p class="raw-detail-top-p2">
							<span v-if="index == showIndex">收起</span>
							<span v-else>展开</span>
							<i class="icon" v-if="index == showIndex"></i>
							<i class="icon icon2" v-else></i>
						</p>
					</div>
					<div class="raw-detail-list" v-show="index == showIndex">
						<div
							class="raw-detail-li"
							v-for="(raw, rawIndex) in item.details"
							:key="rawIndex"
							@click="rawClick(raw, item)"
						>
							<p class="p1">{{ raw.productName }}</p>
							<p class="p2">
								<span class="orange">
									{{ raw.retailComplaintQty }}
								</span>
								<span>{{ raw.unitName }}</span>
							</p>
							<p class="p3">
								<span class="orange">{{ raw.amount }}</span>
								<span>元</span>
								<i class="more"></i>
							</p>
						</div>
					</div>
				</div>
			</div>
			<img
				class="bottom"
				alt="没有更多了"
				src="../assets/images/img_hint_bottom.png"
			/>
		</div>
		<van-calendar
			color="#1989fa"
			v-model="show"
			type="range"
			:min-date="minDate"
			@confirm="onConfirm"
		/>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import { config } from "@/common/apis";
import { Toast } from "vant";
import md5 from "js-md5";

export default {
	name: "customerComplaintsList",
	props: {},
	components: {},
	data() {
		return {
			navList: [],
			list: [],
			showIndex: -1,
			show: false,
			date: "", // 显示出来的日期
			rangeDate: "", //接口用的日期
			navItem: "", //当前分类
			complaintId: "", //客诉单id
			productCode: "", //物资编码
			minDate: new Date(2021, 1, 1)
		};
	},
	computed: {
		...mapGetters(["userNumber", "authToken"])
	},
	watch: {},
	created() {},
	mounted() {
		this.navList = config.NAV_LIST;
		let index = this.$route.query.index || 0;
		this.navListClick(this.navList[index]);
	},
	methods: {
		/**
		 * 回到工作台首页
		 */
		backHome() {
			try {
				// eslint-disable-next-line no-undef
				uni.switchTab({
					url: "/pages/index_copy/index_copy"
				});
			} catch (error) {
				console.log(error);
			}
		},
		/**
		 * 展开详情
		 */
		showItem(item, index) {
			if (this.showIndex !== index) {
				this.showIndex = index;
			} else {
				this.showIndex = -1;
			}
		},
		formatDate(date) {
			return `${date.getFullYear()}-${date.getMonth() +
				1}-${date.getDate()}`;
		},
		onConfirm(date) {
			const [start, end] = date;
			this.date = `${this.formatDate(start)} ~ ${this.formatDate(end)}`;
			this.rangeDate = [this.formatDate(start), this.formatDate(end)];
			this.show = false;
			this.getData();
		},
		/**
		 * 导航切换
		 */
		navListClick(item) {
			this.navItem = item;
			this.date = "";
			this.rangeDate = "";
			this.getData();
		},
		/**
		 * 跳转到详情页面
		 * 非待裁决，存列表，方便上一条下一条切换
		 */
		rawClick(raw, item) {
			const complaintId = raw.complaintId;
			const productCode = raw.productCode;
			try {
				if (this.navItem.type !== "list_wait_with_ruling") {
					const list = [];
					this.list.map(item => {
						item.details.map(val => {
							list.push(val);
						});
					});
					sessionStorage.setItem("staffList", JSON.stringify(list));
				} else {
					sessionStorage.removeItem("staffList");
				}
			} catch (e) {
				console.log(e);
			}
			const page = this.navItem.page;
			const complaintStateName = item.complaintStateName;
			switch (complaintStateName) {
				case "已裁定":
					this.$router.push({
						path: "customerComplaintsDetail5",
						query: { complaintId, productCode }
					});
					break;
				case "已确认":
					this.$router.push({
						path: "customerComplaintsDetail3",
						query: { complaintId, productCode }
					});
					break;
				default:
					this.$router.push({
						path: "customerComplaintsDetail" + page,
						query: { complaintId, productCode }
					});
			}
		},
		/**
		 * 获取列表数据
		 */
		getData() {
			this.showIndex = -1;
			this.list = [];
			const para = {
				userNumber: this.userNumber,
				rangeDate: this.rangeDate,
				complaintState: this.navItem.type,
				complaintId: this.complaintId,
				productCode: this.productCode,
				sign: md5(this.userNumber + config.SALT)
			};
			Toast.loading();
			axios({
				method: "POST",
				url: config.API_BASE_URI + "app/sus/staff/list",
				headers: {
					"X-Auth-Token": this.authToken
				},
				data: para,
				timeout: 1000 * 60 // 请求超时时间默认60秒
			})
				.then(res => {
					Toast.clear();
					if (res.data.code == 0) {
						this.list = res.data.data.complaints;
					} else {
						Toast(res.data.msg);
					}
					console.log(res);
				})
				.catch(err => {
					Toast.clear();
					Toast(err.message);
				});
		}
	},
	filters: {}
};
</script>

<style scoped>
.header {
	height: 3.4rem;
	background: url("../assets/images/img_appeal_bg.png") no-repeat;
	background-size: contain;
}

.top {
	display: flex;
	align-items: center;
	position: relative;
	justify-content: center;
	height: 1.2rem;
}

.top .close {
	width: 0.6rem;
	height: 0.6rem;
	background-image: url("../assets/images/icon_back_1icons_blue.png");
	background-repeat: no-repeat;
	background-size: 0.6rem 0.6rem;
	background-position: center center;
	position: absolute;
	left: 0;
	top: 0;
	padding: 0.3rem;
}

.top .title {
	font-size: 0.36rem;
	font-weight: bold;
	color: #ffffff;
	line-height: 0.5rem;
}

.nav {
	width: 6.9rem;
	height: 0.62rem;
	background: rgba(0, 38, 149, 0.8);
	border-radius: 0.3rem;
	margin: 0.1rem 0.3rem 0 0.3rem;
	display: flex;
	align-items: center;
}

.nav .nav-li {
	width: 1.7rem;
	height: 0.52rem;
	background: none;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 0.26rem;
	color: #ccd4ea;
	font-size: 0.32rem;
	font-weight: bold;
	font-family: PingFangSC-Medium, PingFang SC;
}

.nav .nav-li.active {
	color: #03299b;
	background: linear-gradient(90deg, #f6f8ff 0%, #b4c7ff 100%);
}

.content {
	position: absolute;
	top: 2.3rem;
	bottom: 0;
	width: 7.5rem;
	background: #f5f6fa;
	border-radius: 0.2rem 0.2rem 0rem 0rem;
	overflow-y: scroll;
}

.date-select {
	width: 6.9rem;
	height: 0.8rem;
	background: #ffffff;
	border-radius: 0.5rem;
	display: flex;
	align-items: center;
	margin: 0.3rem;
	position: relative;
}

.date-select .icon-date {
	width: 0.28rem;
	height: 0.28rem;
	background: url("../assets/images/icon_date.png") no-repeat;
	background-size: contain;
	margin: 0 0.2rem 0 0.3rem;
}

.date-select .date {
	font-size: 0.28rem;
	font-family: PingFangSC-Medium, PingFang SC;
	color: #888888;
}

.date-select .date.active {
	color: #333;
	font-weight: bold;
}

.date-select .icon-more {
	width: 0.24rem;
	height: 0.24rem;
	background: url("../assets/images/day_review_icon_go_blue.png") no-repeat;
	background-size: contain;
	position: absolute;
	right: 0.3rem;
}

.data-li {
	width: 6.9rem;
	background: #ffffff;
	box-shadow: 0rem 0.04rem 0.1rem 0rem rgba(192, 205, 221, 0.3);
	border-radius: 0.2rem;
	margin: 0 0.3rem 0.3rem 0.3rem;
	overflow: hidden;
	position: relative;
	box-sizing: border-box;
	padding: 0.76rem 0.3rem 0 0.3rem;
}

.data-li .li-top {
	width: 3.42rem;
	height: 0.48rem;
	position: absolute;
	top: 0;
	left: 0;
}

.data-li .li-top .bg {
	position: absolute;
	width: 3.42rem;
	height: 0.48rem;
	left: 0;
	top: 0;
	z-index: 3;
	background: url("../assets/images/icon_appeal_date.png") no-repeat;
	background-size: contain;
	display: flex;
	align-items: center;
}

.data-li .li-top .date {
	font-size: 0.24rem;
	font-weight: bold;
	color: #ffffff;
	margin-left: 1.7rem;
}

.data-li .li-top .type-name {
	position: absolute;
	width: 1.52rem;
	height: 0.48rem;
	background: url("../assets/images/img_appeal_ruling.png") no-repeat;
	background-size: contain;
	left: 3rem;
	z-index: 1;
	display: flex;
	align-items: center;
	padding-left: 0.4rem;
	font-size: 0.24rem;
	color: #f88b50;
}

.data-li .li-store-name {
	height: 0.32rem;
	font-size: 0.32rem;
	font-weight: bold;
	color: #333333;
	line-height: 0.32rem;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	margin-bottom: 0.3rem;
}

.li-supplier-name {
	font-size: 0.28rem;
	color: #333333;
	line-height: 0.28rem;
	margin-bottom: 0.3rem;
}

.li-number {
	color: #888888;
	font-size: 0.28rem;
	line-height: 0.28rem;
	display: flex;
	align-items: center;
	margin-bottom: 0.3rem;
}

.li-number-p1 {
	flex-shrink: 0;
	width: 3.42rem;
}

.raw-detail {
	background: #fbfbfb;
	border-radius: 0.2rem;
	margin-bottom: 0.3rem;
}

.raw-detail-top {
	width: 6.3rem;
	height: 0.88rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 0.3rem;
}

.raw-detail-top-p1 {
	font-size: 0.28rem;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: bold;
	color: #666666;
}

.raw-detail-top-p2 {
	display: flex;
	align-items: center;

	font-size: 0.24rem;
	font-weight: 400;
	color: #888888;
}

.raw-detail-top-p2 .icon {
	width: 0.18rem;
	height: 0.18rem;
	background-size: contain;
	background-repeat: no-repeat;
	background-image: url("../assets/images/icon_unfold.png");
	margin-left: 0.1rem;
	transform: rotate(90deg);
	transition: 0.2s;
}
.raw-detail-top-p2 .icon2 {
	transform: rotate(0deg);
}

.raw-detail-li {
	display: flex;
	align-items: center;
	margin: 0 0.3rem;
	height: 0.88rem;
	border-top: 1px solid #f1f1f1;
}

.raw-detail-li .p1 {
	width: 2.3rem;
	font-size: 0.28rem;
	color: #888888;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow-x: hidden;
}

.raw-detail-li .p2 {
	width: 1.44rem;
	text-align: right;
	margin-left: 0.19rem;
	font-size: 0.24rem;
	white-space: nowrap;
}

.raw-detail-li .orange {
	font-size: 0.28rem;
	font-weight: bold;
	margin-right: 0.04rem;
}

.orange {
	color: rgba(248, 139, 80, 1);
}

.raw-detail-li .p3 {
	width: 1.71rem;
	margin-left: 0.12rem;
	font-size: 0.24rem;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.raw-detail-li .p3 .more {
	width: 0.24rem;
	height: 0.24rem;
	background: url("../assets/images/day_review_icon_go_blue.png") no-repeat;
	background-size: contain;
}

/deep/ .van-calendar__confirm {
	width: 6.9rem;
	height: 1rem;
	background: linear-gradient(90deg, #68b3fd 0%, #5c85ff 100%);
	border-radius: 0.2rem;
	font-size: 0.36rem;
}

img.bottom {
	width: 2.64rem;
	height: 0.72rem;
	margin: 0.4rem 2.43rem;
}
</style>
